import React from 'react';
import { normalizeUrl } from '../utils/sprintGoalLinks';

const chipBase = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  padding: '4px 10px',
  borderRadius: 8,
  fontWeight: 700,
  textDecoration: 'none',
  border: '1px solid',
  whiteSpace: 'nowrap',
};

const chipSizes = {
  sm: { fontSize: '0.78rem' },
  md: { fontSize: '0.82rem', padding: '5px 12px' },
};

const openBtnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 12px',
  borderRadius: 8,
  border: '1px solid #7CCAF0',
  background: '#EAF6FD',
  color: '#2C63AE',
  fontWeight: 700,
  fontSize: '0.78rem',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

export const SprintReferenceLinks = ({ brdLink, figmaLink, size = 'sm', style }) => {
  const brd = normalizeUrl(brdLink);
  const figma = normalizeUrl(figmaLink);
  if (!brd && !figma) return null;

  const sizeStyle = chipSizes[size] || chipSizes.sm;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', ...style }}>
      {brd && (
        <a
          href={brd}
          target="_blank"
          rel="noopener noreferrer"
          title={brd}
          style={{
            ...chipBase,
            ...sizeStyle,
            background: '#EAF6FD',
            borderColor: '#7CCAF0',
            color: '#2C63AE',
          }}
        >
          📄 BRD ↗
        </a>
      )}
      {figma && (
        <a
          href={figma}
          target="_blank"
          rel="noopener noreferrer"
          title={figma}
          style={{
            ...chipBase,
            ...sizeStyle,
            background: '#faf5ff',
            borderColor: '#d8b4fe',
            color: '#7e22ce',
          }}
        >
          🎨 Figma ↗
        </a>
      )}
    </div>
  );
};

export const SprintGoalLinkInput = ({
  label,
  value,
  onChange,
  disabled,
  inputStyle,
  labelStyle,
}) => {
  const href = normalizeUrl(value);
  // Typed something that yields no URL: the save path runs the same extractor,
  // so this would be dropped silently. Say so instead.
  const invalid = Boolean(String(value || "").trim()) && !href;

  return (
    <div>
      <label style={labelStyle}>{label}</label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'stretch' }}>
        <input
          style={{ ...inputStyle, flex: 1, minWidth: 0 }}
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder="https://..."
        />
        {href ? (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={openBtnStyle}
            title={`Open ${label}`}
          >
            Open ↗
          </a>
        ) : (
          <span
            style={{
              ...openBtnStyle,
              opacity: 0.45,
              pointerEvents: 'none',
              borderColor: '#e2e8f0',
              background: '#f8fafc',
              color: '#94a3b8',
            }}
          >
            Open ↗
          </span>
        )}
      </div>
      {invalid ? (
        <p style={{ margin: '4px 0 0', fontSize: '0.72rem', color: '#b45309' }}>
          Include http:// or https:// — this won't be saved as a link.
        </p>
      ) : null}
    </div>
  );
};
